"use es6";

import { ApolloLink } from "apollo-stack-hubspot/@apollo/client/link/core/ApolloLink";
export var execute = ApolloLink.execute;